import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/customfields/$id/edit')({
  component: () => null,
});
